export default __webpack_public_path__ + "static/media/Front-Angola-Mall.f0e8bf6c.jpg";